import script from "./CatalogProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogProducts.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogProducts.vue?vue&type=style&index=0&id=fcb9ecfe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcb9ecfe"]])

export default __exports__